import { ReactElement, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ResultAction, ResultActionMethods } from '@cashier/cashier-model';
import { convertToUrl, eventBus, EventFactory } from '@cashier/cashier-shared';
import { cn, Loader } from '@cashier/cashier-ui';

import { useHiddenFormContext } from '../../../contexts';
import { FallbackLink } from '../../fallbackLink';

import styles from './styles.module.scss';

export interface PaymentProgressProps {
  applyAction: (
    submitFormData: (
      method: ResultActionMethods,
      url: string,
      data: { [key: string]: string },
    ) => void,
    renderContent: (content: string) => void,
  ) => void;
  resultAction: ResultAction;
  handleFallbackInitiated: (submitForm: () => void) => void;
}

export const PaymentProgress = ({
  applyAction,
  handleFallbackInitiated,
}: PaymentProgressProps): ReactElement => {
  const { t } = useTranslation();
  const { submitForm } = useHiddenFormContext();
  const submitFormData = useCallback(
    (
      method: ResultActionMethods,
      url: string,
      data: { [key: string]: string },
    ) => {
      if (ResultActionMethods.GET === method) {
        eventBus.emit(
          EventFactory.paymentProcessed(200, {
            redirectUrl: convertToUrl(url, data),
          }),
        );
        eventBus.emit(EventFactory.paymentAttributesChanged([]));
      } else {
        eventBus.emit(EventFactory.submitProviderForm(method, url, data));
        eventBus.emit(EventFactory.paymentAttributesChanged([]));
      }
    },
    [],
  );

  const renderContent = (output: string) => {
    eventBus.emit(
      EventFactory.paymentProcessed(200, {
        html: output,
      }),
    );
    eventBus.emit(EventFactory.paymentAttributesChanged([]));
  };

  useEffect(() => {
    applyAction(submitFormData, renderContent);
  }, [applyAction, submitFormData]);

  return (
    <div>
      <div className={cn([styles.wrapper, styles.parentHeight])}>
        <Loader theme="colored" size="medium" />
        <div className={styles.text}>{t('paymentProgress.title')}</div>
      </div>
      <FallbackLink
        version={'v3'}
        handleClick={() => handleFallbackInitiated(submitForm)}
      />
    </div>
  );
};
